import {FComponent} from "../f-component";

interface P {
    next;
    action;
    onDone;
    cleanup;
}
interface S {
    running: boolean,
}

export class TaskRunner extends FComponent<P,S> {

    constructor(props, context) {
        super(props, context);

        this.state = {
            running: false,
        };

        const checkAndRun = async () => {
            const {action} = this.props;
            const {running} = this.state;
            if (!action || running) {
                return;
            }
            this.setState({running: true});

            const result = await action();

            const {onDone} = this.props; // This props is different from props above, due to async nature
            onDone(result);
            this.setState({running: false});
        };

        this.onChanged(checkAndRun);
    }

    render() {
        const {next} = this.props;
        return next({});
    }
}